import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/home-product-video")({
  component: lazyRouteComponent(() => import("./-pages/admin.home-product-video")),
  head: () => ({
    meta: [
      { title: "بلوك منتج + فيديو — إدارة" },
      {
        name: "description",
        content: "تحكّم ببلوك المنتج والفيديو في الصفحة الرئيسيّة: المنتج، الفيديو، النصوص.",
      },
    ],
  }),
});
